module.exports = __webpack_public_path__ + "img/je.bd50e25b.svg";